<template>
  <can-create toggle>
    <v-menu style="z-index: 18">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          rounded
          color="primary"
          v-bind="attrs"
          class="mr-4"
          v-on="on"
        >
          <v-icon left>
            mdi-plus
          </v-icon> Create
        </v-btn>
      </template>
      <v-list dense>
        <v-subheader>CREATE</v-subheader>
        <is-multiverse toggle>
          <v-list-item to="/ui/universes/create">
            <v-list-item-icon>
              <v-icon>$vuetify.icons.universe</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-button font-weight-medium">
              New Universe
            </v-list-item-title>
          </v-list-item>
        </is-multiverse>
        <v-list-item to="/ui/apps/create">
          <v-list-item-icon>
            <v-icon>
              $vuetify.icons.app
            </v-icon>
          </v-list-item-icon>
          <v-list-item-title class="text-button font-weight-medium">
            New App
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </can-create>
</template>

<script>
  export default {
    name: 'CreateNew',
    props: {
      name: String,
    },
  }
</script>
